import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
// Include call API
import { getParameterAPI } from "../../../api/parameters";
import { updatePararamGroupFailed } from './actions';
//Account Redux states
import { UPDATE_PARAMGROUP } from './actionTypes';



const paramsAPI = getParameterAPI();

// Is user register successfull then direct plot user in redux.
function* updateParamGroup({ payload: { paramGroup, user,history } }) {
    try {
       yield call(paramsAPI.updateParamGroup, paramGroup, user.token);
        history.go()
     
    } catch (error) {
        yield put(updatePararamGroupFailed(error));
    }
}

export function* watchParamGroupUpdate() {
    yield takeEvery(UPDATE_PARAMGROUP, updateParamGroup);
}

function* updateParamGroupSaga() {
    yield all([fork(watchParamGroupUpdate)]);
}

export default updateParamGroupSaga;